import { PlatformCode } from 'type/common';
import { api } from './api';

export const rank_apis = {
	getRankingList: async (platform_code: PlatformCode) => {
		const data = await api.get(`/rank/${platform_code}/follower/rate/total/monthly`);

		return data?.data.result;
	},
};
